import { render, staticRenderFns } from "./RegisterClientLayout.vue?vue&type=template&id=73765af4&scoped=true"
import script from "./RegisterClientLayout.vue?vue&type=script&lang=js"
export * from "./RegisterClientLayout.vue?vue&type=script&lang=js"
import style0 from "./RegisterClientLayout.vue?vue&type=style&index=0&id=73765af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73765af4",
  null
  
)

export default component.exports